module.exports = __webpack_public_path__ + "static/water_glacier22-b4f4d2077eaa6ca45e267847803296c6.jpg";